//import mockedFilters from "../../mock/filters";
import request from "@/utils/request"

/****************
 *    Brands
 ****************/
export function getMarques() {
  return request({
    url: "/api/brands",
    method: "get"
  })
}

/**
 *
 * @param {Object} params - request params
 */
export function createBrand(data, params = {}) {
  return request({
    url: "/api/brands",
    method: "post",
    params,
    data
  })
}

/**
 *
 * @param {Number} id - brand id to update
 * @param {Object} params - request params
 */
export function updateBrand(id, data, params = {}) {
  return request({
    url: "/api/brands/" + id,
    method: "put",
    params,
    data
  })
}

/**
 *
 * @param {Number} id - brand id to delete
 */
export function deleteBrand(id) {
  return request({
    url: "/api/brands/" + id,
    method: "delete"
  })
}

/****************
 *    Supports
 ****************/
export function getSupports(params) {
  return request({
    url: "/api/supports",
    method: "get",
    params
  })
}

/**
 *
 * @param {Object} params - request params
 */
export function createSupport(data, params = {}) {
  return request({
    url: "/api/supports",
    method: "post",
    params,
    data
  })
}

/**
 *
 * @param {Object} params - request params
 */
export function updateSupport(id, data, params = {}) {
  return request({
    url: "/api/supports/" + id,
    method: "put",
    params,
    data
  })
}

/**
 *
 * @param {Number} id - support id to delete
 */
export function deleteSupport(id) {
  return request({
    url: "/api/supports/" + id,
    method: "delete"
  })
}
/****************
 *    Themes
 ****************/
export function getThematiques(params) {
  return request({
    url: "/api/themes?all=1",
    method: "get",
    params
  })
}

/**
 *
 * @param {Object} params - request params
 */
export function createTheme(data, params = {}) {
  return request({
    url: "/api/themes",
    method: "post",
    params,
    data
  })
}

/**
 *
 * @param {Number} id - theme id to update
 * @param {Object} params - request params
 */
export function updateTheme(id, data, params = {}) {
  return request({
    url: "/api/themes/" + id,
    method: "put",
    params,
    data
  })
}

/**
 *
 * @param {Number} id - theme id to delete
 */
export function deleteTheme(id) {
  return request({
    url: "/api/themes/" + id,
    method: "delete"
  })
}

/****************
 *  Categories
 ****************/
/**
 *
 * @returns {Array} of categories
 */
export function getCategories() {
  return request({
    url: "/api/categories",
    method: "get"
  })
}
